import { ComponentChildren } from 'preact'
import { Dropdown } from 'semantic-ui-react'

import './menu.css'

const Menu = ({ children, ...rest }: { children: ComponentChildren }) => {
  return <Dropdown.Menu {...rest}>{children}</Dropdown.Menu>
}

export default Menu
